import Vue from 'vue'
import fetch from './fetch'
import { utils } from '@ccprivate/admin-toolkit'
import * as login from './login'
import * as chart from './chart'
const service = {
  state: {},
  fetch,
  ...login,
  ...chart
}

Vue.prototype.$service = utils.wrapService(service)
